import { CardType } from '@core/types/card-deck';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC } from 'react';

import CardHandler from './CardHandler';

const Features: FC = () => (
  <CardHandler type={CardType.Feature}>
    <H2>Trainings-Inhalte</H2>
    <Paragraph>Worauf setzen wir unsere Schwerpunkte?</Paragraph>
    <Paragraph>
      Systema Training hat viele verschiedene Inhalte. Hier sind einige von ihnen. Klicke auf die
      einzelnen Bilder, um mehr Informationen anzuzeigen.
    </Paragraph>
  </CardHandler>
);

export default Features;
